import * as React from 'react';
 
import * as userUtil from '../../stores/user/util';

import Select from 'react-select';
import { filter } from 'lodash';

import moment from 'moment';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IUser } from '../../stores/jotai/base';
import { Theme } from '@mui/material';

// Menu items
// The order listed is the order they should render (I realize JSON doesn't gauarantee
// order, but untill it's a problem whatever)

interface IProps {
    handleAction: (slug: string) => void;

    menuTitle: string;
    itemWidth: string;
    controlWidth?: string;

    config: any;

    user: IUser;
    org: OrgState;
    app: AppState;
    currentPage: string;
    theme?: Theme
}

interface Refs {
    [key: string]: React.Component<any, any>;
    periodDropdown: Select;
}

interface IState {
    isMenuOpen: boolean;
}


export class ResourcesDropdown extends React.Component<IProps, IState> {
    state: IState = {
        isMenuOpen: false
    }

    refs: Refs;

    componentDidMount() {
        ((typeof window !== "undefined") ? document : {}).addEventListener("keydown", this.handleEscapePress, false);
    }

    componentWillUnmount() {
        ((typeof window !== "undefined") ? document : {}).removeEventListener("keydown", this.handleEscapePress, false);
    }

    handleEscapePress = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                isMenuOpen: false
            });
        }
    }

    checkItemValidity = (menuItem: any) => {
        const {
            user,
            org
        } = this.props;

        const userRoles = userUtil.getAllRoles(user, org);
        const isSystemAdministrator = userUtil.isSystemAdmin(userRoles);
        const isNormalAdmin = userUtil.isAdmin(userRoles);
        const isInstructor = userUtil.isInstructor(userRoles);

        if (menuItem.roles === "*") {
            return true;
        }

        const isRoleOpposite = menuItem?.roles.includes("!");
        const cleanedRole    = menuItem?.roles.replace("!", "");

        if (cleanedRole === "system_admin") {
            if (isRoleOpposite && isSystemAdministrator === false) {
                return true;
            }

            if (isRoleOpposite === false && isSystemAdministrator) {
                return true;
            }
        }

        if (cleanedRole === "admin") {
            if (isRoleOpposite && isNormalAdmin === false) {
                return true;
            }

            if (isRoleOpposite === false && isNormalAdmin) {
                return true;
            }
        }

        if (cleanedRole === "instructor") {
            // Check for this up front, in all scenarios show this to instructor only roles
            if (isSystemAdministrator || isNormalAdmin) {
                return true;
            }

            if (isRoleOpposite && isInstructor === false) {
                return true;
            }

            if (isRoleOpposite === false && isInstructor) {
                return true;
            }
        }

        return false;
    }

    getOptions = () => {
        const items = filter(this.props?.config, potentitalMenuItem => {
            return this.checkItemValidity(potentitalMenuItem);
        });

        return items;
    }

    toggleOpen = () => {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    calculateClassName = () => {
        return "react-select-dd";
    }

    calculateMenuProvider = (provided) => {
        const { theme } = this.props;
        return {
            ...provided,
            position: 'relative',
            top: '0px',
            width: '220px',
            zIndex: theme?.custom?.menuZIndex,
            boxShadow: theme?.custom?.menuBoxShadow,
            left: '-10px',
            margin: "2px 0 0",
        }
    }

    calculateControlProvider = (provided, state) => {
        return {
            ...provided,
            border: 'none',
            backgroundColor: 'transparency',
            outline: 'none',
            position: 'relative',
            boxShadow: 'none',
            paddingTop: '0px',
            marginLeft: '3px',
            minHeight: '25px',
            height: '25px',
            paddingBottom: '0px',
            fontWeight: 400,
        }
    }

    calculateMenuPortalStyle = (baseStyle, state) => {
        const { theme } = this.props;
        return {
        ...baseStyle,
        zIndex: theme?.custom?.menuZIndex + 1, // to place it above clickAwayTracker
        }
    }

    calculateStyleProvider = (provided, state) => {
        const { isSelected } = state;
        const { theme } = this.props;
        return {
            ...provided,
            backgroundColor: isSelected ? theme?.custom?.mainButtonHighlight : "white",
            cursor: "pointer",
            width: "220px",
            position: "static",
            lineHeight: "20px",
            "&:hover": {
                backgroundColor: isSelected
                    ? theme?.custom?.mainButtonHighlight
                    : theme?.custom?.hoverOptionColor,
            },
        };
    }

    calculateValueContainer = (provided, state) => {
        return {
            ...provided, 
            padding: '0px',
        }
    }

    renderInput = (innerProps) => {
        return (
            <span
                style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                }}
                onTouchStart={() => {
                    this.toggleOpen();
                }}
                onClick={() => {
                    this.toggleOpen();
                }}
            >
                {this.props?.menuTitle}
                <ExpandMoreIcon
                    sx={{
                        fontSize: "18px",
                    }}
                />
            </span>
        );
    }

    renderPlaceholder = (innerProps) => {
        return <span></span>
    }

    renderDropdownIndicator = (innerProps) => {
        return <span onClick={() => {
            this.toggleOpen();
        }} style={{}}>
            
        </span>
    }

    render() {
        const { isMenuOpen } = this.state;
        const { controlWidth, currentPage } = this.props;
        const { theme } = this.props;
        const selectedOption = this.getOptions().find(
            (option) => option.value === currentPage?.split("/")[1] || ""
        ) || null;

        const styleProvider = {
            option: this.calculateStyleProvider,
            control: this.calculateControlProvider,
            menu: this.calculateMenuProvider,
            valueContainer: this.calculateValueContainer, 
            menuPortal: this.calculateMenuPortalStyle,
        }

        const componentOverrides = {
            Input: this.renderInput,
            Placeholder: this.renderPlaceholder,
            DropdownIndicator: this.renderDropdownIndicator,
            SingleValue: this.renderPlaceholder,
            IndicatorSeparator: this.renderPlaceholder
        }

        const clickAwayTracker = <span onClick={() => {
            this.setState({
                isMenuOpen: false
            });
        }} style={{ position: 'fixed', top: '0px', left: '0px', height: '100vh', width: '100vw', zIndex: theme?.custom?.menuClickAwayZIndex }} />

        return (
            <span
                style={{
                    display: "block",
                    position: "relative",
                    width: controlWidth ? controlWidth : "71px",
                    top: "0px",
                    height: "25px",
                }}
            >
                {isMenuOpen ? clickAwayTracker : undefined}
                <Select
                    menuIsOpen={isMenuOpen}
                    components={componentOverrides}
                    className={this.calculateClassName()}
                    styles={styleProvider}
                    options={this.getOptions()}
                    openMenuOnFocus={true}
                    onChange={(options: any) => {
                        this.props.handleAction(options.value);

                        this.toggleOpen();
                    }}
                    menuPortalTarget={document.body}
                    onMenuClose={() => {
                        this.setState({
                            isMenuOpen: false,
                        });
                    }}
                    value={selectedOption}
                />
            </span>
        );
    }
}
